module.exports = __webpack_public_path__ + "img/zhu5.1d951361.png";